import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=da28afda&scoped=true&"
import script from "./Telephone.vue?vue&type=script&lang=js&"
export * from "./Telephone.vue?vue&type=script&lang=js&"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=da28afda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da28afda",
  null
  
)

export default component.exports